import React from "react";
import { IconT } from "types/utils";
import styles from "./ConferenceIcon.module.less";

type ConferenceIconPropsT = IconT & {
  shade?: "dark" | "light";
};

const ConferenceIcon = ({ height = "23", width = "23", shade }: ConferenceIconPropsT) => {
  return (
    <div
      style={{ height, width }}
      className={shade === "light" ? styles.conferenceIcon_light : styles.conferenceIcon_dark}
    />
  );
};

export default ConferenceIcon;
